import axios from "axios";

export const api = axios.create({
	baseURL: "https://backend-baguncinha.onrender.com",
	// baseURL: "http://localhost:3000",
	timeout: 35000,
});
